import { i18n } from '@selfserve/react-utils';

import { Property } from '../types';

export const STATUS_VAL = 'Status';

export const checklistProperties: Property[] = [
  { text: i18n.t('common.name'), value: 'Name', mandatory: true },
  { text: i18n.t('common.description'), value: 'Description', mandatory: true },
  { text: i18n.t('common.kaltura_application'), value: 'Kaltura application', mandatory: true },
  { text: i18n.t('common.type'), value: 'Type', sortingValue: 'type', defaultChecked: true },
  { text: i18n.t('common.status'), value: STATUS_VAL, sortingValue: 'status', defaultChecked: true },
];

export const defaultChecklistProperties = checklistProperties.filter(
  ({ mandatory, defaultChecked }) => mandatory || defaultChecked
);
